export const TEMPLATE_VARIABLES = [
    "{responsavel}",
    "{escola}",
    "{data_vencimento}",
    "{link_fatura}",
    "{link_pix}",
    "{valor}",
    "{plano}",
    "{link_sistema}",
];

export const TEMPLATE_VARIABLES_HINT = TEMPLATE_VARIABLES.join(", ");
